export default __webpack_public_path__ + "static/media/menu_my_recordings.dff5e6e8.svg";